import { Component, Input } from '@angular/core';

@Component({
    selector: 'dbbutton',
    templateUrl: 'button.html'
})
export class ButtonComponent {

    @Input('customClass') customClass: any;
    @Input('disabled') disabled: any = false;

}



// WEBPACK FOOTER //
// ./src/components/button/button.ts